import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDropDownTreeMixin from './KendoDropDownTreeMixin'

export default {
    name: 'kendo-dropdowntree',
    mixins: [ KendoDropDownTreeMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement

        var tagName = (this.$props.checkboxes || this.$props.checkboxesCheckChildren ||
            this.$props.checkboxesName || this.$props.checkboxesTemplate) ? 'select': 'input'
   
        return h(tagName, [
            this.$slots['kendo-hierarchicaldatasource']
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowntree-vue-wrapper/src/KendoDropDownTree/index.js